import styled from 'styled-components'

enum colors {
  default = '#e0e1e2',
  defaultHover = '#cacbcd',

  blue = '#2185d0',
  blueHover = '#1678c2',

  green = '#21ba45',
  greenHover = '#16ab39',

  orange = '#f2711c',
  orangeHover = '#f26202',

  pink = '#e03997',
  pinkHover = '#e61a8d',

  red = '#db2828',
  redHover = '#d01919'
}

interface IButton {
  color?: 'blue' | 'green' | 'orange' | 'pink' | 'red'
}
export const Button = styled.button<IButton>`
  color: ${({ color }) => color ? '#fff' : 'rgba(0,0,0,.6)'};
  cursor: pointer;
  display: inline-block;
  min-height: 1em;
  outline: 0;
  border: none;
  margin: 0 .25em 0 0;
  padding: .78571429em 1.5em .78571429em;
  font-weight: 700;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  border-radius: .28571429rem;
  background: ${({ color }) => color ? colors[color] : colors.default};
  transition: opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease,-webkit-box-shadow .1s ease;

  &:hover {
    color: ${({ color }) => color ? '#fff' : 'rgba(0,0,0,.8)'};
    background-color: ${({ color }) => color ? colors[`${color}Hover`] : colors.defaultHover};
  }
`